<template>
  <HistoryCenter :itemDetail="itemDetail"/>
</template>

<script>
import HistoryCenter from '@/views/public_0983cc/trade/detail/HistoryCenter.vue'

export default {
  props:{
    itemDetail: {
      type: Object,
      default: () => {},
    },
  },
  components:{
    HistoryCenter
  }
}
</script>

<style>

</style>